// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__6Q99o","none":"Button_none__AIshO","accent":"Button_accent__2mRv5","red":"Button_red__3ham3","green":"Button_green__3VzFV"};